import type { SelectOption } from '@/app/components/shared/forms/SelectField'
import type { FilterOption } from '@/app/lib/api/types-api'

/**
 * `data.filters.<key>.items[]` (contrato de `/data`) → opciones de
 * `SelectField`. Único mapeo compartido por todos los envoltorios de
 * `ListingFilters` que consumen `FilterBlock` (Promociones, Subcategoría, Lo
 * más vendido, Agenda, Recinto) — antes había una copia idéntica en cada uno.
 *
 * - `disabled`: una opción con 0 resultados en la combinación de filtros activa
 *   queda visible pero no seleccionable (no lleva a un listado vacío por
 *   sorpresa).
 * - `count`: el recuento se propaga tal cual para que `SelectField` lo pinte
 *   junto al nombre ("Este mes (1)"). Los bloques que no lo traen (p. ej.
 *   `sort`) dejan `count` en `undefined` y no pintan nada.
 */
export function toSelectOptions(items: readonly FilterOption[]): SelectOption[] {
  return items.map((item) => ({
    label: item.name,
    value: String(item.value),
    disabled: item.count === 0,
    count: item.count,
  }))
}

/**
 * Placeholder del selector "Ordenar por" cuando no hay orden aplicado: indica
 * el orden por defecto del listado (la primera opción de `sort.items`, que es
 * la que el backend aplica sin `sort`). Sin items, cae al texto genérico.
 */
export function sortPlaceholder(items: readonly FilterOption[]): string {
  const defaultName = items[0]?.name
  return defaultName ?? 'Ordenar por'
}
